export default __webpack_public_path__ + "static/media/4-colocada.3870c249.png";